import React from 'react';
import { useAuthState } from '@trp-ta-nitro/auth-react';
import styles from './styles.css';
import {
  accountTypes,
  setAccountAccessUrl,
  isRetirement
} from '../../flows/shared/utils';
import RetirementContactSection from './RetirementContactSection';
import config from '../../config';

const NonFundedConfirmation = ({ accountType }) => {
  const authState = useAuthState();
  const hasRetailEntitlement = authState?.entitlements?.includes(
    'TRP_RET_EXTERNAL_USER_ACCESS'
  );

  return (
    <>
      <section className="next-instructions">
        <div className="step-contents">
          <h3 className="confirmation-section-headers">
            Your new account is ready to view
          </h3>
          <p>
            It&#39;s fast and easy to manage your account online. From your
            dashboard, you can:
            <ul>
              <li aria-describedby="fund-new-account-bullet">
                <dd
                  className="non-funded-list-item"
                  id="fund-new-account-bullet">
                  Fund your new account.
                </dd>
              </li>
              <li aria-describedby="link-bank-account-bullet">
                <dd
                  className="non-funded-list-item"
                  id="link-bank-account-bullet">
                  Link a bank account.
                </dd>
              </li>
              <li aria-describedby="setup-recurring-contributions-bullet">
                <dd
                  className="non-funded-list-item"
                  id="setup-recurring-contributions-bullet">
                  Set up recurring contributions.
                </dd>
              </li>
              {accountType !== accountTypes.UGMAUTMA && (
                <li aria-describedby="add-update-benes-bullet">
                  <dd
                    className="non-funded-list-item"
                    id="add-update-benes-bullet">
                    {isRetirement(accountType)
                      ? 'Add beneficiaries.'
                      : 'Add or update beneficiaries.'}
                  </dd>
                </li>
              )}
            </ul>
            <a
              className="underlined-confirmation-links"
              id="manageYourAccountLink"
              data-name="manageYourAccountLink"
              href={setAccountAccessUrl(hasRetailEntitlement)}
              target="_blank"
              rel="noopener noreferrer">
              Manage your account
            </a>
          </p>
        </div>
      </section>
      {!isRetirement(accountType) && (
        <section className="next-instructions">
          <div className="step-contents">
            <h3 className="confirmation-section-headers">
              Add a trusted contact
            </h3>
            <p>
              A Trusted Contact is a resource for T. Rowe Price to contact on
              your behalf, if necessary, to help protect your accounts from
              financial exploitation, or to confirm your contact information if
              we are unable to reach you. Click{' '}
              <a
                className="nonfunded-confirmation-links"
                href={
                  hasRetailEntitlement
                    ? `${config(
                        'clxUrl'
                      )}/usis/my-accounts/profile/trusted-contacts`
                    : `${config('clxUrl')}/usis/login/logout?sdurl=${config(
                        'clxUrl'
                      )}/usis/my-accounts/profile/trusted-contacts`
                }
                target="_blank"
                rel="noopener noreferrer">
                trusted contact
              </a>{' '}
              to add, or update and learn more.
            </p>
          </div>
        </section>
      )}
      {isRetirement(accountType) && <RetirementContactSection />}
      <style jsx>{styles}</style>
    </>
  );
};

export default NonFundedConfirmation;
